import React, { useEffect, useState } from 'react'
import styles from './AuthorPage.module.css'
import { Col, Row, Spin, Tabs, message } from 'antd'
import AuthorDetails from '../AuthorDetails/AuthorDetails'
import { useDispatch, useSelector } from 'react-redux'
import { fetchAuthorDetails } from '../../Slices/AuthorDetailsSlice'
import { fetchUserBookmarks, fetchUserInteractions } from '../../Slices/PublicCollectionsDataSlice'
import AuthorCollections from '../AuthorCollections/AuthorCollections'
import { ErrorPage } from '../SmallComponents/SmallComponents'
import { changeAdding, changeRemoving, removeLastWindowNHQ, setWindowNHQ } from '../../Slices/WindowNHQSlice'
import { useLocation, useNavigationType } from 'react-router-dom'
import { useIsMount } from '../../Custom Hooks/useIsMount'
import { Helmet } from 'react-helmet'
import { LoadingOutlined } from '@ant-design/icons'

const AuthorPage = () => {

  const [authorId, setAuthorId] = useState<any>(null);
  const [authorLoading, setAuthorLoading] = useState<any>(true);
  const {authorDetails, loading, error}= useSelector((state:any)=> state.authorDetails)
  const windowNHQ= useSelector((state:any)=> state.windowNHQ?.data)
  const removing= useSelector((state:any)=> state.windowNHQ?.removing)
  const adding= useSelector((state:any)=> state.windowNHQ?.adding)
  const content= useSelector((state:any)=> state.windowNHQ?.content)
  const {collections, likedCollections, dislikedCollections, userBookmarks}= useSelector((state:any)=> state.publicCollectionsData)
  // const {details, statistics, top_collections, top_contributions, featured_collections, pinned_collection} = authorDetails ?? [];
  const navigationType = useNavigationType();
  const dispatch:any = useDispatch();
  const location = useLocation();

  useEffect(()=>{
    if(navigationType === 'POP'){
      dispatch(removeLastWindowNHQ())
    }
    else if (navigationType === 'PUSH'){
      console.log('NAV PUSH')
    }
  }, [window.location.pathname])

  useEffect(()=>{
    if (windowNHQ?.length < 1) {
    if(((window as any).NHQ?.current_id)){
      setAuthorId((window as any).NHQ?.current_id)
      dispatch(setWindowNHQ({id: (window as any).NHQ?.current_id, type: 'author', slug : authorDetails?.username}))
   }
   else {
    // message.error("Author ID not found")
  }
  setAuthorLoading(false)
  }
  }, [])

  useEffect(()=>{
      dispatch(fetchUserBookmarks());
      dispatch(fetchUserInteractions());

      if(content?.length > 0){
      let str = window.location.pathname.split('/')
     let authorId = null;
     for(let ele of content) {
      // if (ele.slug === str[str.length - 1]) {
        authorId = ele.id;
        break;
      // }
    }
    console.log(authorId, 'WINDOW AUTHOR ID')
    console.log(content, 'WINDOW Content ID')
     if (authorId){
      setAuthorId(authorId)
      dispatch(changeRemoving('none'));
      dispatch(changeAdding('none'));
    }
    else {
      setAuthorId(false)
      // message.error("Author ID not found")
    }
    setAuthorLoading(false)
  }


  }, [location.pathname, content, windowNHQ])

  useEffect(()=>{
    if(authorId ){
      dispatch(fetchAuthorDetails(authorId));
    }
  }, [authorId])


  const antIcon = (
    <LoadingOutlined className={styles.customLoader}  spin />
  );
  
  // console.log(authorDetails, 'deatils')


  return ( 
     authorLoading ?  
      <Col style={{minHeight: "100vh"}}>
           <Spin
             indicator={antIcon}
             className={styles.spinner}
             spinning={true}
             fullscreen
           />
           </Col>
           :
  authorId  ?
  <>
      <Helmet>
    <title>{`${authorDetails?.details?.name} - NotableHQ`}</title>
        <meta name="description" content={authorDetails?.details?.bio} />
        <meta name="theme-color" content="#008f68" />
    </Helmet>
    <Row gutter={[0,30]} className={styles.authorPageMain}>
        <Col  span={24}>
            <AuthorDetails loading={loading} details={authorDetails?.details} />
        </Col>
        <Col span={24}>
            <AuthorCollections authorDetailsLoading={loading} pinnedCollection={authorDetails?.pinned_collection} statistics={authorDetails?.statistics} featuredCollections={authorDetails?.featured_collections} topCollections={authorDetails?.top_collections} authorId={authorId}/>
        </Col>
    </Row>
    </>

    : 
    <>
    <ErrorPage button status={"authorNotFound"} buttonText={"Back to collections"} subTitle/>
    </>
    ) 
  
}

export default AuthorPage